import {createFileRoute} from '@tanstack/react-router';
import {SavingsAccountWithdrawalUpdateReceiverCallbackPage} from 'features/deposit/withdrawal/SavingsAccountWithdrawalUpdateReceiverCallbackPage';

export const Route = createFileRoute(
  '/_protected/withdrawal/accounts/callback',
)({
  component: SavingsAccountWithdrawalUpdateReceiverCallbackPage,
  validateSearch: (search) => {
    return {
      accountId: search.accountId as string | undefined,
      accountNumber: search.accountNumber as string | undefined,
      status: search.status as string | undefined,
    };
  },
});
